export const TERMS_OF_SERVICE = {
    title: 'Terms of Service',
    type: 'TERMS_OF_SERVICE',
    version: 1,
    effective_date: '01-01-2000',
    markup: `<h1>Terms of Service</h1>
    <p><strong>Effective Date:</strong> Upon account creation or engagement of services with BCK Consulting</p>
    
    <h2>1. Introduction</h2>
    <p>By creating an account with BCK Consulting ("we", "us", "our"), you ("Client", "you", "your") agree to be bound by these Terms & Conditions. These terms govern your access to and use of our services, including but not limited to website design, development, consulting, hosting, and technical support.</p>
    
    <h2>2. Definitions</h2>
    <ul>
      <li><strong>Virtual Assets:</strong> Any digital property managed or maintained by BCK Consulting on behalf of the Client. This may include but is not limited to websites, domain names, hosting accounts, email services, digital content, analytics data, plugins, and platform credentials.</li>
      <li><strong>Project:</strong> A defined scope of work agreed upon by the Client and BCK Consulting. Projects may be quoted either a monetary amount or a number of hours. At least one-third (1/3) of the project fee is due before the project begins. Scope adjustments may be made during the project based on the Client's evolving needs.</li>
      <li><strong>Support Plan:</strong> A service that may accompany a Hosting Plan or be purchased independently. Support Plans allocate a defined number of monthly hours for assistance, maintenance, or consultation without hourly billing. Plans include scheduled Check-Ins for reviewing account status or discussing virtual assets.</li>
      <li><strong>Billable Hours:</strong> Billable hours incurred by clients either without an active Support Plan or in excess of their plan. These may include:
        <ul>
          <li><strong>Support Hours:</strong> Time spent addressing support-related needs, such as change requests, content updates, troubleshooting, and general maintenance of the client's virtual assets.</li>
          <li><strong>Consulting Hours:</strong> Time spent assisting with advanced technical topics, strategic guidance, or questions requiring specialized expertise in web, software, or business technology.</li>
        </ul>
        Both types of hours are billed at the hourly rate outlined in the client’s onboarding documentation and are invoiced monthly.
      </li>
      <li><strong>Check-In:</strong> A scheduled session where clients can discuss anything related to their account, their digital assets, or services offered by BCK Consulting.</li>
    </ul>
    
    <h2>3. Services Provided</h2>
    <p>BCK Consulting offers website design, branding, online business identity consulting, software development, hosting, and technology consulting. Specific deliverables and timelines will be defined on a per-project basis.</p>
    
    <h2>4. Performance of Services</h2>
    <p>We operate as an independent contractor. We determine the methods and hours used to fulfill service obligations unless otherwise agreed in writing.</p>
    
    <h2>5. Payment Terms</h2>
    <p>Clients agree to pay for services as quoted or agreed upon. Work outside the quoted scope ("Additional Services") will be billed as Support & Consulting Hours. Invoices are issued monthly and due within 30 calendar days. Late payments are subject to a 1.5% monthly fee or the maximum amount allowed by law.</p>
    
    <h2>6. Expenses</h2>
    <p>Clients will reimburse pre-approved, project-related out-of-pocket expenses such as:</p>
    <ul>
      <li>Printing and copies</li>
      <li>Travel or mileage (at the federal rate)</li>
      <li>Licensing fees and subscriptions</li>
      <li>Third-party software or hosting costs</li>
    </ul>
    <p>No single expense exceeding $20 will be charged without prior written approval.</p>
    
    <h2>7. Intellectual Property</h2>
    <p><strong>Client Ownership:</strong></p>
    <ul>
      <li>Custom graphics, text, media, and branding created specifically for the Client</li>
      <li>Unique website layouts or designs built exclusively for the Client</li>
    </ul>
    <p><strong>BCK Consulting Retains Ownership of:</strong></p>
    <ul>
      <li>Reusable design templates, code libraries, or backend frameworks</li>
      <li>Proprietary workflows, development tools, and modules used across clients</li>
    </ul>
    <p>Client-provided materials remain the property of the Client.</p>
    
    <h2>8. Social Media & Account Ownership</h2>
    <p>Accounts and digital properties created or managed on behalf of the Client are considered the Client’s property. All access credentials will be handed over upon request or project conclusion.</p>
    
    <h2>9. Confidentiality</h2>
    <p>We agree to protect all proprietary or sensitive information disclosed by the Client, including but not limited to:</p>
    <ul>
      <li>Business strategies</li>
      <li>Technical information</li>
      <li>Pricing, costs, or future plans</li>
      <li>Customer or subscriber lists</li>
    </ul>
    <p>This clause remains in effect beyond the termination of services.</p>
    
    <h2>10. Termination</h2>
    <p>Either party may terminate services with 15 days’ written notice. Upon termination, the Client agrees to pay for all completed services and approved expenses incurred up to the termination date.</p>
    
    <h2>11. Support Scope</h2>
    <p>Support includes routine website maintenance, uptime monitoring, and general troubleshooting. Major revisions, redesigns, or urgent support requests may be subject to additional billing under Support & Consulting Hours.</p>
    
    <h2>12. Third-Party Services</h2>
    <p>BCK Consulting may recommend or integrate third-party services. We are not liable for updates, outages, or policy changes from these platforms. Clients are responsible for complying with third-party terms.</p>
    
    <h2>13. Portfolio Use</h2>
    <p>Unless otherwise requested in writing, BCK Consulting reserves the right to showcase completed projects in our portfolio or marketing materials.</p>
    
    <h2>14. Data & Privacy Compliance</h2>
    <p>Clients are responsible for complying with all applicable data privacy regulations (e.g., GDPR, CCPA). BCK Consulting can assist but does not assume legal liability.</p>
    
    <h2>15. Interruption of Service (Force Majeure)</h2>
    <p>Neither party is liable for service delays due to uncontrollable events (natural disasters, power outages, war, etc.). Obligations may be delayed or terminated after 30 days of disruption.</p>
    
    <h2>16. Dispute Resolution</h2>
    <p>Disputes will first be addressed through informal discussion. If unresolved, disputes will be handled via arbitration in Saint Louis County, Missouri, unless otherwise agreed.</p>
    
    <h2>17. Hosting & Uptime Disclaimer</h2>
    <p>BCK Consulting relies on third-party infrastructure and cannot guarantee uninterrupted access to hosted services. We will make reasonable efforts to minimize downtime, but availability is not guaranteed.</p>
    
    <h2>18. Client Responsibilities</h2>
    <p>Clients agree to:</p>
    <ul>
      <li>Provide timely access to needed materials and credentials</li>
      <li>Maintain up-to-date backups unless managed backup services are contracted</li>
      <li>Secure their login information and report unauthorized access</li>
    </ul>
    
    <h2>19. Late Payment Penalties</h2>
    <p>Invoices not paid within 30 days are subject to a 1.5% monthly late fee (or maximum allowed by law). Services may be suspended until payments are brought current.</p>
    
    <h2>20. Changes to Terms</h2>
    <p>These Terms & Conditions may be updated at any time. Continued use of BCK Consulting services after updates constitutes agreement to the revised terms.</p>
    
    <h2>21. Applicable Law</h2>
    <p>These Terms & Conditions are governed by the laws of the State of Missouri.</p>
    
    <p><strong>Thank you for choosing BCK Consulting. We’re here to help your business grow online with clarity and confidence.</strong></p>    
    `
}